module.exports = __webpack_public_path__ + "media/ets/24-06a6e100.png";